import { Injectable } from '@angular/core';
import { assign } from 'lodash-es';
import * as Utils from '../utils/utils';


@Injectable({providedIn: 'root'})
export class UtilsService {
  constructor() {
    assign(this, Utils);
  }
}
